import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { getFaq, getPrompt } from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import PaginationComponent from "../Components/Pagination";
import SearchComponent from "../Components/CommanSearch";
import DeleteModal from "../Components/DeleteModal";
import AdminActions from "../Redux/Actions/AdminActions";

export default function Prompts() {
  const promptList = useSelector((e) => e.userAuth.promptList);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const totalEntries = promptList?.pagination?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [promptId, setPromptId] = useState("");

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handlePageChange = (page) => {
    setCurrentPage(page + 1);
    navigate(`/prompts?page=${page + 1}`);
  };

  const handleChange = async (id) => {
    setPromptId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteUser = () => {
    dispatch(AdminActions.deletePrompt({ promptId })).then(
      (res) => {
        if (res?.payload?.status == 200) {
          toast.success(res?.payload?.message);
          Inialize();
        } else {
          toast.error(res?.payload?.message);
        }
        handleCloseDeleteModal();
      }
    );
  };

  const Inialize = () => {
    try {
      const params = new URLSearchParams(location.search);
      const page = params.get("page") || currentPage;
      setCurrentPage(page);
      const searchQuery = params.get("search") || "";
      const queryParams = searchQuery
        ? { search: searchQuery }
        : { page: page, limit };

      dispatch(startstopLoading(true));
      dispatch(getPrompt(queryParams)).then((res) => {
        dispatch(startstopLoading(false));
      });

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Inialize();
  }, [location.search, dispatch, currentPage, location.pathname, limit]);

  console.log(promptList, 'promptList');


  return (
    <Layout>
      <Container fluid>
        <div className="filters">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>Prompts</h2>
            </div>
            <div className="user-search">
              <div className="drop-down">
                <div className="select-box">
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => setLimit(e.target.value)}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
              <div className="search-tab">
                <div className="input-search">
                  <SearchComponent heading="prompts" />
                </div>
                <div
                  onClick={() => navigate(`/add-prompt`)}
                  className="export-box"
                >
                  <p>Add New Prompt</p>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <Table size="sm" className="table-cmn">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Que</th>
                    <th> Answer</th>
                    <th> Action</th>
                  </tr>
                </thead>
                <tbody>
                  {promptList?.quickPrompts?.map((res, index) =>
                    <tr key={index}>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{index + 1}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{res.question}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{res.answer}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="action">
                          <div
                            onClick={() => handleChange(res._id)}
                          >
                            <img
                              src={
                                require("../Assets/Images/delete-icon.svg").default
                              }
                            />
                          </div>
                          <div
                            onClick={() => navigate(`/add-prompt?id=${res._id}`)}
                          >
                            <img
                              src={
                                require("../Assets/Images/view-icon.svg").default
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                </tbody>
              </Table>
              {promptList?.pagination?.total > 1 && (
                <PaginationComponent
                  currentPage={currentPage - 1}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={totalEntries}
                  entriesPerPage={entriesPerPage}
                />
              )}
            </div>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              {" "}
              © {new Date().getFullYear()}, Made with ❤️ by <span>Codobux</span>
            </p>
          </div>
        </div>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDeleteUser}
        name={"Prompt"}
      />
    </Layout>
  );
}
